import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ReactComponent as NoSearchResults } from 'assets/images/EmptyState/NoSearchResults.svg';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

export const ResourceSearchEmptyState = () => {
  const { translation } = useTranslationContext();

  return (
    <Stack alignItems="center" spacing={2} sx={{ py: 6 }}>
      <NoSearchResults role="img" aria-label="No search results" width={240} height={250} />
      <Typography
        variant="headline"
        textAlign="center"
        fontWeight={500}
        sx={{ color: (theme) => theme.palette.primary.main }}
      >
        {translation('search_results_empty_title')}
      </Typography>
      <Typography
        variant="callout"
        textAlign="center"
        sx={{ color: (theme) => theme.palette.grey[800] }}
      >
        {translation('search_results_empty_body')}
      </Typography>
    </Stack>
  );
};

ResourceSearchEmptyState.displayName = 'ResourceSearchEmptyState';
